import { Flex, Input, Spin, Badge } from "antd";
import React, { useState, useRef } from "react";
import { GetMessages, GetUserMessages } from "../../api's/chatbot";
import { useToken } from "../../common/helper";
import { playBeepSound } from "../../common/utils/utils";
import { useEffect } from "react";
import { useWebSocket } from "../../context/WebSocketContext";
// Components
import { ChatbotIcon, EmojiIcon, SendIcon } from "../../assets/icons/icons";
// Assets
import chatImg from "../../assets/images/user-img.png";

import ChatIcon from "../../assets/images/ChatIcon";

function Chatbot() {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [unreadDots, setUnreadDots] = useState({});
  const { webSocketService, selectedUserID, setSelectedUserID } =
    useWebSocket();
  const [selectedUser, setSelectedUser] = useState({});
  const [trigger, setTrigger] = useState(false);
  const [selectedUserMessages, setSelectedUserMessages] = useState([]);
  const { token, removeToken, userID } = useToken();

  const handleUserClick = (userInfo) => {
    if (selectedUserID !== userInfo?.id) {
      setLoading(true);
      setSelectedUserMessages([]);
      setSelectedUser(userInfo);
      setSelectedUserID(userInfo?.id);
    }

    setUnreadDots((prevDots) => ({
      ...prevDots,
      [userInfo.id]: false,
    }));
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
    }
  };

  const fetchMessages = () => {
    GetMessages(token)
      .then((res) => {
        const data = res?.data ? res.data?.data : null;
        console.log("Messages Data:", data);
        if (data) {
          if (data?.is_success) {
            const messages = data?.data ? data.data : [];
            if (messages) {
              setMessages(messages);
            }
          } else {
            message.error(data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        // hideSpin();
      });
  };
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView();
    }
  }, [selectedUserMessages]);

  useEffect(() => {
    if (!webSocketService || !userID) return;

    const handleNewMessage = (data) => {
      setTrigger(false);
      try {
        const parsedData = JSON.parse(data);
        console.log(
          "📩 New Parsed Message Received in Component chatbot:",
          parsedData
        );
        if (
          parsedData?.sender_id !== selectedUser?.id &&
          parsedData?.sender_id !== userID
        ) {
          setUnreadDots((prevDots) => ({
            ...prevDots,
            [parsedData.sender_id]: true,
          }));
          playBeepSound();
          setTrigger(true);
        }

        if (
          parsedData?.sender_id === userID ||
          parsedData?.sender_id !== selectedUser?.id
        ) {
          console.warn("⚠ Ignoring self-sent message:", parsedData.message);
          return;
        }

        const newReceivedMessage = {
          id: parsedData?.message_id || crypto.randomUUID(),
          created_at: parsedData?.created_at || new Date().toISOString(),
          updated_at: parsedData?.updated_at || new Date().toISOString(),
          is_archived: false,
          message: parsedData?.message || "",
          is_read: false,
          created_by: {
            id: parsedData?.sender_id,
            name: "",
            email: "",
            role: "User",
            designation: null,
            title: "",
            country_code: "",
            phone_number: "",
          },
          updated_by: null,
          conversation:
            parsedData?.conversation || "337434cb-8ea6-4be3-8216-a6f9a25de881",
        };

        setSelectedUserMessages((prevState) => {
          let updatedMessages = prevState?.data?.data
            ? [...prevState.data.data]
            : [];

          updatedMessages.push(newReceivedMessage);

          return {
            ...prevState,
            data: {
              ...prevState?.data,
              data: updatedMessages,
            },
          };
        });
      } catch (error) {
        console.error("❌ Error parsing WebSocket message:", error);
      }
    };

    webSocketService.removeMessageListener(handleNewMessage);
    webSocketService.onMessage(handleNewMessage);

    return () => {
      webSocketService.removeMessageListener(handleNewMessage);
    };
  }, [webSocketService, userID, selectedUser]);

  const sendMessage = () => {
    setTrigger(false);
    if (message.trim() !== "") {
      const newMessage = {
        id: crypto.randomUUID(),
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        is_archived: false,
        message: message,
        is_read: false,
        created_by: {
          id: userID,
          name: "You",
          email: "",
          role: "User",
          designation: null,
          title: "",
          country_code: "",
          phone_number: "",
        },
        updated_by: null,
        conversation: "337434cb-8ea6-4be3-8216-a6f9a25de881",
      };

      let updatedMessages = selectedUserMessages?.data?.data
        ? [...selectedUserMessages.data.data]
        : [];

      updatedMessages.push(newMessage);

      setSelectedUserMessages((prevState) => ({
        ...prevState,
        data: {
          ...prevState?.data,
          data: updatedMessages,
        },
      }));
      webSocketService.sendMessage({
        message: message,
        sender_id: userID,
        user_id: userID,
      });

      setMessage("");
      setTrigger(true);
    }
  };

  useEffect(() => {
    if (selectedUser?.id) {
      GetUserMessages(token, selectedUser?.id)
        .then((res) => {
          const data = res?.data ? res.data?.data : [];
          setSelectedUserMessages(data);
          console.log("Fetched Messages for User:", data);
        })
        .catch((error) => {
          console.error("Error fetching user messages:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedUser?.id]);

  useEffect(() => {
    fetchMessages();
  }, [selectedUserMessages, trigger]);

  return (
    <div className="chatbox">
      <div className="chat-sidebar">
        <div className="chat-sidebar-header">
          <h6 className="chat-heading">All Chats ({messages?.data?.length})</h6>
        </div>
        <div className="chat-inbox">
          {messages?.data
            ?.slice() 
            ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
            ?.map((msg) => (
              <div
                key={msg.id}
                onClick={() => handleUserClick(msg.user_info)}
                className={`
                ${unreadDots[msg.user_info.id] ? "unread-chat" : ""} 
                ${
                  selectedUser?.id == msg.user_info.id
                    ? "active-chat"
                    : "chat-inbox-list "
                }`} 
              >
                <Badge
                  dot={unreadDots[msg.user_info.id]}
                  offset={[-5, 5]}
                  color="red"
                  style={{
                    width: "10px",
                    height: "10px",
                  }}
                >
                  <img className="chat-inbox-img" src={chatImg} alt="" />
                </Badge>

                <div className="chat-inbox-info">
                  <Flex justify="space-between">
                    <span className="chat-inbox-user">
                      {msg?.user_info?.name || msg?.user_info?.email || "--"}
                    </span>
                    <small className="chat-inbox-time">
                      {new Date(msg.updated_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </small>
                  </Flex>

                  <Flex justify="space-between">
                    <span className="chat-inbox-user">
                      <p className="chat-inbox-msg">{msg?.message || "--"}</p>
                    </span>
                    {/* {msg.unread_count > 0 && (
                      <small
                        className="chat-inbox-time"
                        style={{
                          color: "#3D81FF",
                          backgroundColor: "#3D81FF",
                          color: "white",
                          padding: "3px 1px",
                          borderRadius: "50%",
                          height: "20px",
                          width: "20px",
                          textAlign: "center",
                        }}
                      >
                        {msg.unread_count}
                      </small>
                    )} */}
                  </Flex>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="chatbox-body">
        <div className="chatbox-body-header">
          <Flex gap="middle" align="center">
            <img className="chat-inbox-img" src={chatImg} alt="" />
            <h6 className="chatbox-msg-heading">
              {selectedUser?.name || selectedUser?.email || "--"}
            </h6>
          </Flex>
        </div>
        <div className="chatbox-msg">
          {loading ? (
            <div className="spinner-container">
              <Spin size="large" />
            </div>
          ) : (
            selectedUserMessages?.data?.data
              ?.slice()
              ?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
              ?.map((msg) => (
                <div
                  key={msg.id}
                  className={`chatbot-message-container ${
                    msg?.created_by?.id === selectedUser?.id ? "user" : "mine"
                  }`}
                >
                  {msg?.created_by?.id === selectedUser?.id && (
                    <div
                      className="chatbot-message-avatar"
                      style={{ transform: "scaleX(-1)" }}
                    >
                      <ChatIcon
                        height="24px"
                        width="24px"
                        color="#3D81FF"
                        fillcolor="white"
                      />
                    </div>
                  )}

                  <div
                    className={`chatbot-message-bubble ${
                      msg?.created_by?.id === selectedUser?.id ? "user" : "mine"
                    }`}
                  >
                    <span className="chatbot-message-text">{msg.message}</span>
                    <div
                      className={`chatbot-message-date ${
                        msg?.created_by?.id === selectedUser?.id
                          ? "user"
                          : "mine"
                      }`}
                    >
                      {new Date(msg.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </div>
                  </div>
                </div>
              ))
          )}
          <div ref={messagesEndRef}></div>
        </div>

        <div className="chatbot-composor">
          <div style={{ position: "relative", width: "100%" }}>
            <Input
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type something..."
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  sendMessage();
                }
              }}
            />
            {/* <button className="chatbot-emojies">
              <EmojiIcon width={20} height={20} fill="black" />
            </button> */}
          </div>
          <button className="chatbot-send-button" onClick={sendMessage}>
            <SendIcon width={48} height={48} fill="#266ef1" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Chatbot;
